var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecurity = function SvgSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.462 6.224a1.424 1.424 0 1 1-2.847 0 1.424 1.424 0 0 1 2.847 0M14.038 8.005a16 16 0 0 0-1.836-.07q-1.075-.028-2.147.07a1.844 1.844 0 0 0-1.322 1.813v4.372a.67.67 0 0 0 .653.614.583.583 0 0 0 .583-.614v-4.022h.335v11.163a.801.801 0 1 0 1.602 0v-6.542h.28v6.55a.817.817 0 0 0 1.61 0V10.176h.328v4.022a.58.58 0 0 0 .583.614.685.685 0 0 0 .661-.614V9.826a1.85 1.85 0 0 0-1.33-1.813",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.838 22V5.298L9.876 3.33h4.34l2.039 1.968V22h1.338V4.73L14.753 2H9.34L6.5 4.73V22"
  })));
};
export default SvgSecurity;